var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-widget-body media"},[_c('status-icon',{attrs:{"status":"loading","show-disabled-button":true}}),_vm._v(" "),_c('div',{staticClass:"media-body space-children"},[_c('span',{staticClass:"bold"},[_vm._v("\n      "+_vm._s(_vm.s__("mrWidget|Checking ability to merge automatically"))+"\n    ")])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56dde2de","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_merge_request_widget/components/states/mr_widget_checking.vue
// module id = null
// module chunks = 